/** Shown in the footer and on /status so anyone can tell which website build their browser is running. */
export const WEBSITE_VERSION = "2026.10.19";
